module.exports = function(h, row) {
    return (
        moment(row.available_from).format('DD MMM YYYY') +
        ' - ' +
        moment(row.available_to).format('DD MMM YYYY')
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/couponredeem/available_from_date.jsx